import dayjs from 'dayjs'

/** Convert a complete DD/MM/YYYY date to a valid ISO civil date. */
export const parseCivilDate = (text) => {
  const match = typeof text === 'string' && text.match(/^(\d{2})\/(\d{2})\/(\d{4})$/)
  if (!match) return null

  const isoDate = `${match[3]}-${match[2]}-${match[1]}`
  const date = dayjs(isoDate)
  return date.isValid() && date.format('YYYY-MM-DD') === isoDate
    ? isoDate
    : null
}

export const isIsoCivilDate = (value) =>
  typeof value === 'string' &&
  /^\d{4}-\d{2}-\d{2}$/.test(value) &&
  dayjs(value).isValid() &&
  dayjs(value).format('YYYY-MM-DD') === value
